"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var context_1 = __importDefault(require("atomicComponents/organisms/Dropdown/context"));
var DropdownWithExpandBtn_1 = __importDefault(require("atomicComponents/organisms/Dropdown/DropdownWithExpandBtn"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var hooks_2 = require("containers/ConfirmationModal/hooks");
var CategoryTitle_1 = __importDefault(require("containers/Navbar/styles/CategoryTitle"));
var DropdownOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownOption"));
var single_1 = require("utils/selectors/single");
var tableConf_1 = require("./tableConf");
var utils_1 = require("./utils");
var DropdownOptions = function () {
    var rechargedCustomers = (0, react_redux_1.useSelector)(tableConf_1.customerAgreementsTableConf.config.selector);
    var closeMenu = react_1.default.useContext(context_1.default).closeMenu;
    var dateToday = (0, end2end_1.getISODate)(new Date());
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var prompt = (0, hooks_2.useConfirm)();
    var sortedCustomers = (0, hooks_1.useSortArray)(rechargedCustomers !== null && rechargedCustomers !== void 0 ? rechargedCustomers : [], tableConf_1.customerAgreementsTableConf.extractors);
    var isAdmin = profile === null || profile === void 0 ? void 0 : profile.isAdmin;
    var makeFileName = function (status) { return "Rechargly - ".concat(company === null || company === void 0 ? void 0 : company.name, "'s Agreements (").concat(status, ") ").concat(dateToday, ".csv"); };
    var downloadAllAgreements = function () {
        if (!sortedCustomers) {
            prompt('No agreements found.', '', 'red', 'OK', true);
            return;
        }
        (0, utils_1.exportAgreements)(sortedCustomers, makeFileName('All'), isAdmin);
        closeMenu();
    };
    var downloadAgreementsByStatus = function (downloadAcceptedAgreements) {
        var statuses = downloadAcceptedAgreements ? ['accepted'] : ['sent', 'opened_by_copy_link', 'opened_by_email', 'opened_by_all'];
        var pendingAgreements = sortedCustomers === null || sortedCustomers === void 0 ? void 0 : sortedCustomers.filter(function (customer) { return statuses.includes((0, end2end_1.getCustomerExtendedAgreementStatus)(customer)); });
        if (!pendingAgreements) {
            prompt('No agreements found.', '', 'red', 'OK', true);
            return;
        }
        (0, utils_1.exportAgreements)(pendingAgreements, makeFileName(downloadAcceptedAgreements ? 'Accepted' : 'Sent and Opened'), isAdmin);
        closeMenu();
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "All agreements", autoFocus: true, onClick: downloadAllAgreements }), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Accepted agreements", autoFocus: true, onClick: function () { return downloadAgreementsByStatus(true); } }), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Sent and Opened agreements", onClick: function () { return downloadAgreementsByStatus(false); } })] }));
};
var ExportAgreements = function () { return ((0, jsx_runtime_1.jsxs)(DropdownWithExpandBtn_1.default, { children: [(0, jsx_runtime_1.jsx)(CategoryTitle_1.default, __assign({ px: 2 }, { children: "Export CSV" })), (0, jsx_runtime_1.jsx)(DropdownOptions, {})] })); };
exports.default = (0, SortHoC_1.default)(ExportAgreements, { key: 'name', order: 1 });
